import { render, staticRenderFns } from "./buscador.vue?vue&type=template&id=fd089d1c&"
import script from "./buscador.vue?vue&type=script&lang=ts&"
export * from "./buscador.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports